import { cn } from "@/lib/utils";
import { ChevronDown, ChevronUp, XIcon } from "lucide-react";

interface ErrorHeaderProps {
  message?: string;
  isExpanded: boolean;
  setIsExpanded?: () => void;
  onClose?: () => void;
  zoomScale?: string;
}

export function ErrorHeader({
  message = "An error occurred",
  isExpanded,
  setIsExpanded,
  onClose,
  zoomScale = "1",
}: ErrorHeaderProps) {
  return (
    <div className="flex items-start gap-2 w-full bg-secondary-300 p-3 text-secondary-n-50 relative shrink-0">
      <div
        className="flex flex-col items-center justify-center shrink-0 mt-0.5"
        style={{
          width: `calc(16px * ${zoomScale})`,
          height: `calc(16px * ${zoomScale})`,
        }}
      >
        <img
          src="/icons/ai-chat-status/failed.svg"
          className="shrink-0"
          style={{
            width: `calc(16px * ${zoomScale})`,
            height: `calc(16px * ${zoomScale})`,
          }}
        />
      </div>
      <div
        onClick={setIsExpanded}
        className={cn(
          "flex flex-1 justify-between items-start",
          setIsExpanded && "cursor-pointer",
        )}
      >
        <div
          className="text-secondary-n-50 font-medium text-sm pr-8 line-clamp-2"
          style={{
            fontSize: `calc(13px * ${zoomScale})`,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={message}
        >
          {message}
        </div>
        {!setIsExpanded ? null : isExpanded ? (
          <ChevronUp
            className="text-secondary-n-500 shrink-0 h-4 w-4"
            style={{
              width: `calc(16px * ${zoomScale})`,
              height: `calc(16px * ${zoomScale})`,
            }}
          />
        ) : (
          <ChevronDown
            className="text-secondary-n-500 shrink-0 h-4 w-4"
            style={{
              width: `calc(16px * ${zoomScale})`,
              height: `calc(16px * ${zoomScale})`,
            }}
          />
        )}
      </div>
      {onClose && (
        <button
          className="p-1 rounded hover:bg-secondary-200 transition-colors text-secondary-n-200 hover:text-white absolute"
          style={{
            top: `calc(8px * ${zoomScale})`,
            right: `calc(8px * ${zoomScale})`,
          }}
          onClick={onClose}
          aria-label="Close error overlay"
        >
          <XIcon
            className="h-4 w-4"
            style={{
              width: `calc(16px * ${zoomScale})`,
              height: `calc(16px * ${zoomScale})`,
            }}
          />
        </button>
      )}
    </div>
  );
}

export default ErrorHeader;
